import { Seat } from '../../../types';
import memes from '../../../../memes';
import { PassengerState } from '../../../../Checkout/store/passengers/reducers';

export const isSeatOccupied = memes(
	(seat: Seat, passenger: PassengerState, segmentId: string): boolean =>
		passenger.seats &&
		passenger.seats.some(
			selectedSeat =>
				selectedSeat.segmentId === segmentId && `${selectedSeat.row}${selectedSeat.letter}` === seat.number
		)
);

export const isOccupiedByOtherPassenger = memes(
	(seat: Seat, passengers: PassengerState[], passengerId: string, segmentId: string) => {
		const otherPassengers = passengers.filter(passenger => passenger.id !== passengerId);

		return otherPassengers
			.map(passenger => passenger.seats)
			.filter(Boolean)
			.some(otherPassengerSeat =>
				otherPassengerSeat.some(
					otherSeat =>
						otherSeat.segmentId === segmentId && `${otherSeat.row}${otherSeat.letter}` === seat.number
				)
			);
	}
);

export const findPassengerWithThisSeat = memes((seat: Seat, passengers: PassengerState[], segmentId: string) =>
	passengers.find(
		passenger =>
			passenger.seats &&
			passenger.seats
				.filter(seat => seat.segmentId === segmentId)
				.some(selectedSeat => `${selectedSeat.row}${selectedSeat.letter}` === seat.number)
	)
);
